import { headerBlock, footerBlock, buildEmpleadorBlock } from '../blocks/header'
import { buildIndicadoresSection } from '../blocks/indicadores'
import { buildGraficosSection } from '../blocks/graficos'

export const buildPage1 = ({
  today,
  periodoDesde,
  periodoHasta,
  totalPages,
  empleador,
  reportData,
  indicadores,
  tipoAccidentePng,
  tipoGravedadPng,
  evolucionDenunciasPng,
}) => `
  <div class="page">
    ${headerBlock(today, periodoDesde, periodoHasta)}

    <!-- DATOS EMPLEADOR -->
    <div class="section-title">DATOS DEL EMPLEADOR</div>
    ${buildEmpleadorBlock(empleador, reportData)}

    <!-- INDICADORES -->
    <div class="section-title">INDICADORES</div>
    ${buildIndicadoresSection(indicadores)}

    <!-- GRAFICOS -->
    ${buildGraficosSection(tipoAccidentePng, tipoGravedadPng)}

    <!-- EVOLUCION MENSUAL DE DENUNCIAS -->
    ${
      evolucionDenunciasPng
        ? `
    <div class="chart chart-evolucion">
      <div class="chart-title">EVOLUCIÓN MENSUAL DE LAS DENUNCIAS</div>
      <div class="chart-body">
        <img src="${evolucionDenunciasPng}" alt="Evolución mensual de denuncias">
      </div>
    </div>`
        : ''
    }

    <div style="margin-top:auto;">
      <div style="height:56px;"></div>
      ${footerBlock(1, totalPages)}
    </div>
  </div>`
